import React from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';
import UnderConstruction from '../components/UnderConstruction';
import { useGenericEffect } from '../components/UseGenericEffect';
import GeneralTestimonials from '../content/general_testimonials';


export default function Testimonials() {
  const { strings } = useLanguage();

    useGenericEffect(() => {    
    }, [strings.lang_code]);

  return (
    <>
      <Hero title={strings.pages.testimonials.title} eyebrow={strings.pages.testimonials.eyebrow} />
      <main className="page-content">
           <div class="content-container-menu" id="content-container-menu">     
              <div className="menu-item" id="general">{strings.pages.testimonials.general}</div> 
              {/*    
              <div className="menu-item" id="option_1">{strings.pages.testimonials.option_1}</div>      
              <div className="menu-item" id="option_2">{strings.pages.testimonials.option_2}</div>  
              <div className="menu-item" id="option_3">{strings.pages.testimonials.option_3}</div>
              <div  className="menu-item"id="option_4">{strings.pages.testimonials.option_4}</div>
              */}
          </div>  
          <div class="content-table max-centered">
              <div class="content-container">    
                  <div class="content-container-main" id="content-container-main"></div>   
              </div>
              <div class="hidden" id="loadstate">general</div>
              <div id="general_section" class="hidden">
                   <h1>{strings.pages.testimonials.general}</h1>     
                    <GeneralTestimonials lang={strings.lang_code} />  
              </div>
              {/*
               <div id="option_1_section" class="hidden">
                   <h1>{strings.pages.testimonials.option_1}</h1>     
                     <UnderConstruction />    
              </div>
               <div id="option_2_section" class="hidden">
                   <h1>{strings.pages.testimonials.option_2}</h1>     
                      <UnderConstruction />
              </div>
               <div id="option_3_section" class="hidden">
                   <h1>{strings.pages.testimonials.option_3}</h1>     
                      <UnderConstruction />
              </div>
                <div id="option_4_section" class="hidden">
                   <h1>{strings.pages.testimonials.option_4}</h1>     
                      <UnderConstruction />
              </div>
              */}
       </div>
      </main>
    </>
  );
}